module.exports = __webpack_public_path__ + "static/media/rosh-hashana.fe387430.svg";